import type { Editor } from "@tiptap/core";

/**
 * Resolve the append target for editor popups (the `@` mention list and the `/`
 * slash-command menu).
 *
 * The composer is often mounted inside a drawer whose `backdrop-blur` (and slide
 * animation transform) establishes a new containing block. Appending tippy
 * popups to `document.body` then mispositions them — Popper resolves the caret
 * rect and the popup in mismatched coordinate spaces and the popup lands at the
 * viewport origin (top-left). Appending into the composer's own bubble-menu
 * container — the same target the bubble menus use — keeps the popup in the same
 * positioning context as the editor, so it anchors to the caret.
 *
 * Falls back to `document.body` when the editor isn't inside a composer
 * (defensive; the container is always rendered alongside the editor today).
 */
export function resolvePopupContainer(editor: Editor): HTMLElement {
  const root = editor.view.dom.closest("[data-email-composer]");
  const container = root?.querySelector<HTMLElement>(
    "[data-email-bubble-container]",
  );
  return container ?? document.body;
}
